import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {Button, Box, Grid, Typography, Container} from '@material-ui/core';
import {Document} from 'components/icons/icons';
import {useFlags} from 'hooks';
import useBrowserTitle from 'hooks/useBrowserTitle';
import {GoBackButton} from './AddSeaservice';

const useStyles = makeStyles(theme => ({
    button: {
        backgroundColor: `${theme.palette.primary.light2}`,
        border: 0,
        borderRadius: 3,
        height: 70,
        width: 70,
        margin: '2px 30px',
        padding: '10px',
    },
}));

const iconProps = {
    height: 50,
    width: 50,
};

const FormTypeOption = ({
    formName,
    formPath,
    formDescription,
    icon: Icon,
    disabled,
}) => {
    const classes = useStyles();

    return (
        <>
            <Button
                disabled={disabled}
                variant='contained'
                className={classes.button}
                to={formPath}
                component={Link}
            >
                <Icon {...iconProps} />
            </Button>

            <Typography align='center'>{formName}</Typography>
            {formDescription?.length > 0 && (
                <Typography align='center'>{formDescription}</Typography>
            )}
        </>
    );
};

const AddOtherTraining = () => {
    useBrowserTitle(`| Add Other Training`);
    const {
        nvic_form_active: nvicActive,
        toar_form_active: toarActive,
        tankerman_form_active: tankermanActive,
    } = useFlags();

    return (
        <Container maxWidth='xs'>
            <Box textAlign='center'>
                <Grid
                    container
                    spacing={2}
                    direction='column'
                    justifyContent='flex-start'
                    alignItems='center'
                >
                    <Grid item />
                    <Grid item>
                        <Typography variant='h6' align='center'>
                            Great! Let's get started! What kind of Training
                            Document are you adding?
                        </Typography>
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='STCW NVIC Checksheet'
                            icon={Document}
                            key='nvic'
                            formPath={'/forms/nvic'}
                            disabled={!nvicActive}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='Towing Officer Assessment Record (TOAR)'
                            icon={Document}
                            key='toar'
                            formPath={'/forms/toar'}
                            disabled={!toarActive}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='Tankerman Company Letter'
                            icon={Document}
                            key='tanker'
                            formPath={'/forms/tankerman'}
                            disabled={!tankermanActive}
                        />
                    </Grid>
                    <Grid item>
                        <GoBackButton />
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default AddOtherTraining;
